export const getElevateMemberPrice = product => {
  const memberPrices = product?.variants
    ?.map(
      variant =>
        variant?.prices?.find(price => {
          return price.id === 'MEMBER';
        })?.sellingPrice
    )
    .filter(price => price !== undefined);

  if (memberPrices.length === 0) {
    return null;
  }

  const lowestMemberPrice = Math.min(...memberPrices);
  return lowestMemberPrice;
};
